import React, { useRef, useImperativeHandle, useEffect, useState, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
    TextField,
    InputAdornment,
    IconButton,
    Avatar,
    Grid,
    Popover,
    Typography,
    Button,
    Switch,
    FormControlLabel,
    Checkbox,
    Card,
    CardContent,
    Fab
} from "@material-ui/core";
import LogoAFIP from "../../../assets/AFIPlogo.png";
import { startAlerta } from "../../../actions/ui/alertas";
import { makeStyles } from "@material-ui/core/styles";
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import moment from "moment";
import "moment/locale/es";
import { ValidatorForm } from 'react-material-ui-form-validator';
import SaveIcon from "@material-ui/icons/Save";

import { useForm } from "../../../hooks/useForm";
import { useValidation } from "../../../hooks/useValidation";
import { CboLocalidades } from "../../cbos/CboLocalidades";
import { CboProvincias } from "../../cbos/CboProvincias";
import { CboSeccionales } from "../../cbos/CboSeccionales";
import {
    fetchAFIP,
    fetchEmpresaXCUIT,
    empresaTraerAFIPSuccess,
    empresaStartInsert,
    empresaStoreOrUpdate,
} from "../../../actions/empresas/empresas";
import { finishSpinner, startSpinner } from "../../../actions/ui/spinner";
import { FORM_ACTIONS } from "../../../utils/constants";
import { ModalVerAfiliadosEmpresa } from "../ModalVerAfiliadosEmpresa";
import { LimpiarObservacionesEmpresa, getObservacionesEmpresa, limpiarDatosSuspensionEmpresa, suspenderCobertura, traerDatosSuspensionEmpresa } from "../../../actions/comunicacionConEmpresas/comunicacionConEmpresas";
import { AlertFinalizadoStepper } from "../../stepper/AlertFinalizadoStepper";
import { NuevaObservacionModal } from "../NuevaObservacionModal";
import { AssignmentReturn } from "@material-ui/icons";
import { enviarSeguimientoEmpresa, getSeguimientoEmpresa } from "../../../actions/empresas/seguimientoEmpresas";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginLeft: 50,
        marginTop: 50,
        marginRight: 50,
        marginBottom: 50
    },
    root2: {
        flexGrow: 1,
    },
    popover: {
        pointerEvents: "none",
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: "center",
        color: theme.palette.text.secondary,
    },
    botonera: {
        marginTop: 25,
    },
    texto: {
        padding: 2,
        margin: 3,
        width: "60vw",
    },
    iconSmall: {
        width: theme.spacing(3),
        height: theme.spacing(3),
    },
    switchBase: {
        color: '#bdbdbd',
        '&$checked': {
            transform: 'translateX(16px)',
            color: '#4CAF50',
            '& + $track': {
                backgroundColor: '#3E8040',
                opacity: 1,
                border: 'none',
            },
        },
    },
    checked: {},
    track: {},
    fab: {
        position: "relative",
        top: theme.spacing(2),
        left: theme.spacing(15),
    },
}));

export const FormEmpresa = React.forwardRef(({ action, setAction, empresa, cerrarPop }, ref) => {
    moment.locale("es");
    const classes = useStyles();
    const dispatch = useDispatch();
    const { items } = useSelector((state) => state.localidades);
    const [disabledCUIT, setdisabledCUIT] = useState(action !== FORM_ACTIONS.CREAR);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [abrirModalAfiliados, setAbrirModalAfiliados] = useState(false);
    const [abrirModalNuevaObservacion, setAbrirModalNuevaObservacion] = useState(false);
    const open = Boolean(anchorEl);
    const { datosSuspensionEmpresa, observacionesEmpresa } = useSelector((state) => state.comunicacionEmpresas);
    const { seguimientoEmpresa } = useSelector((state) => state.empresas);
    const [confirmarSuspension, setConfirmarSuspension] = useState(false);
    const [anchorElSE, setAnchorElSE] = useState(null);


    const openPopSeguimiento = Boolean(anchorElSE);
    const idPopSeguimiento = openPopSeguimiento ? "simple-popover" : undefined;
    const [
        formValues,
        handleInputChange,
        reset,
        setearValor,
        setearValor2,
    ] = useForm(empresa);

    const {
        denominacion,
        domicilio,
        codigoPostal,
        telefono,
        email,
        cuit,
        fechaAlta,
        fechaBaja,
        observacion,
        idSeccional,
        idProvincia,
        idLocalidad,
        suspendida,
        seguimiento,
        observacionSeguimiento,
        fechaAviso
    } = formValues;

    const [datosValidos, setDatosValidos] = useState(true);
    const activeId = useRef(empresa?.cuit);
    const [
        valuesValidation,
        handleInputChangeValidation,
        resetValidation,
        setearValorValidation,
    ] = useValidation(empresa);

    useEffect(() => {
        if(empresa?.cuit){
        dispatch(traerDatosSuspensionEmpresa(empresa?.cuit));
        dispatch(getObservacionesEmpresa(empresa?.cuit));
        dispatch(getSeguimientoEmpresa(empresa?.cuit));
        }
    }, [dispatch, empresa?.cuit])

    useEffect(() => {
       if(observacionesEmpresa !== null){
        dispatch(LimpiarObservacionesEmpresa());
       }
       if(datosSuspensionEmpresa !== null){
        dispatch(limpiarDatosSuspensionEmpresa());
       }
    }, [dispatch, empresa?.cuit])

    useEffect(() => {
        if (seguimientoEmpresa?.length > 0) {
            formValues.observacionSeguimiento = seguimientoEmpresa[0]?.observacion;
            formValues.fechaAviso = seguimientoEmpresa[0]?.fechaAviso;
        }
    }, [dispatch, seguimientoEmpresa[0]?.observacion,seguimientoEmpresa[0]?.fechaAviso])

    const handleCPChange = (e) => {
        let reg = new RegExp("^[0-9]+$");
        if (e.target.value === "" || reg.test(e.target.value)) {
            setearValor("codigoPostal", e.target.value);
        }
    };

    const handleCUITChange = (e) => {
        let reg = new RegExp("^[0-9]+$");
        if (e.target.value === "" || reg.test(e.target.value)) {
            setearValor("cuit", e.target.value);
        }
        if (e.target.value.toString().length === 11) {
            setearValorValidation("cuit", false);
        }
    };

    const handleLocalidadChange = (e) => {
        if (items?.length > 0) {
            const localidad = items.find(
                (loc) => parseInt(loc?.id_localidad) === parseInt(e.target.value)
            );
            setearValor2(
                "idLocalidad",
                localidad?.id_localidad,
                "idProvincia",
                localidad?.id_provincia
            );
        }
    };

    const handleTelefonoChange = (e) => {
        let reg = new RegExp("^[0-9]+$");
        if (e.target.value === "" || reg.test(e.target.value)) {
            setearValor("telefono", e.target.value);
        }
    };

    const handleCuitAFIP = async () => {
        if (cuit?.toString().length === 11) {
            dispatch(startSpinner());
            setearValorValidation("cuit", false);
            dispatch(startAlerta(`Buscando empresa...`, "info"))

            const empresaRequest = await dispatch(fetchEmpresaXCUIT(cuit));
            if (empresaRequest) {
                dispatch(
                    startAlerta(`La empresa ya existe`, "info", empresaRequest?.denominacion)
                );
            } else {
                //no existe en padron valido en afip
                const empresaAFIP = await dispatch(fetchAFIP(cuit));

                if (empresaAFIP) {
                    dispatch(empresaTraerAFIPSuccess(empresaAFIP));
                    setdisabledCUIT(true);
                }
            }
            dispatch(finishSpinner());
        } else {
            setearValorValidation("cuit", true);
            dispatch(
                startAlerta(
                    `El CUIT ingresado debe contener 11 digitos`,
                    "error",
                    "Verifique CUIT"
                )
            );
        }
    };

    const validateEmail = (email) => {
        let reg = new RegExp(`[^@ \t\r\n]+@[^@ \t\r\n]+[^@ \t\r\n]+`);
        if (reg.test(email) || email?.length === 0) {
            setearValorValidation("email", false);
        } else {
            setearValorValidation("email", true);
        }
    };

    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        if (empresa && empresa.cuit !== activeId.current) {
            reset(empresa);
            resetValidation(empresa);
            activeId.current = empresa.cuit;
        }
    }, [empresa, reset, resetValidation]);

    useEffect(() => {
        setDatosValidos(true);
        for (var key of Object.keys(valuesValidation)) {
            if (valuesValidation[key]) {
                setDatosValidos(false);
            }
        }
    }, [valuesValidation, datosValidos]);

    useImperativeHandle(ref, () => ({

        guardarEmpresa(e) {
            e.preventDefault();
            if (datosValidos && Object.keys(formValues).length > 0 && formValues.constructor === Object) {
                dispatch(empresaStartInsert(formValues));
                cerrarPop();
            }
            //
        },
    }));

    const handleSubmit = () => {
        const dataEmpresa = {
            "denominacion": denominacion,
            "domicilio": domicilio,
            "codigoPostal": codigoPostal,
            "telefono": telefono,
            "email": email,
            "idSeccional": idSeccional,
            "idUsuario": null,
            "idProvincia": idProvincia,
            "idLocalidad": idLocalidad,
            "cuit": cuit,
            "fechaAlta": fechaAlta,
            "fechaBaja": fechaBaja,
            "observacion": observacion,
            "idMotivoBaja": 0,
            "seguimiento": seguimiento
        }

        dispatch(empresaStoreOrUpdate(dataEmpresa, action === FORM_ACTIONS.CREAR ? null : empresa.idEmpresa))
        if (setAction) {//solo viene cuando se ve o modifica
            setAction(FORM_ACTIONS.VER)
        }
        dispatch(traerDatosSuspensionEmpresa(empresa.cuit));
    }

    const handleChangeSwitchSuspension = (e) => {
        setConfirmarSuspension(true);
        setearValor("suspendida", e.target.checked)
    }

    const handleCloseAlert = () => {
        setConfirmarSuspension(false);
        if (suspendida) {
            setearValor("suspendida", false);
        } else {
            setearValor("suspendida", true);
        }
    }

    const suspensionCobertura = () => {
        dispatch(suspenderCobertura(empresa?.cuit, suspendida, () => {
            dispatch(traerDatosSuspensionEmpresa(empresa?.cuit));
            setConfirmarSuspension(false);
            dispatch(getObservacionesEmpresa(empresa?.cuit));
        }));
    }

    const handleClickPopSeguimiento = (event) => {
        setTimeout(setAnchorElSE, 2000, event.currentTarget);
    };

    const handleClosePopSeguimiento = () => {
        setAnchorElSE(null);
    };
    const handleChangeCheckbox = (e) => {
        setearValor(e.target.name, e.target.checked);
        if (e.target.name === "seguimiento" && e.target.checked) {
            setAnchorElSE(e.currentTarget);
        }
    };
    const handleSeguimientoAdd = (e) => {
        e.preventDefault();
        dispatch(enviarSeguimientoEmpresa(observacionSeguimiento, fechaAviso, true, empresa?.cuit));
    };


    const editarSeguimiento = action === FORM_ACTIONS.VER
        ? handleClickPopSeguimiento
        : null;

    console.log(seguimientoEmpresa)
    return (
        <div className={classes.root}>
            {
                abrirModalAfiliados && (
                    <ModalVerAfiliadosEmpresa
                        open={abrirModalAfiliados}
                        onClose={() => setAbrirModalAfiliados(false)}
                        cuit={empresa?.cuit}
                    />
                )
            }
            {
                abrirModalNuevaObservacion && (
                    <NuevaObservacionModal
                        open={abrirModalNuevaObservacion}
                        onClose={() => setAbrirModalNuevaObservacion(false)}
                        cuit={empresa?.cuit}
                    />
                )
            }
            <ValidatorForm>
                <div>
                    <Popover
                        id="mouse-over-popover"
                        className={classes.popover}
                        classes={{
                            paper: classes.paper,
                        }}
                        open={open}
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "left",
                        }}
                        transformOrigin={{
                            vertical: "top",
                            horizontal: "left",
                        }}
                        onClose={handlePopoverClose}
                        disableRestoreFocus
                    >
                        <Typography>Ingrese CUIT de la Empresa y busque en AFIP</Typography>
                    </Popover>
                </div>

                <Grid container spacing={2}>
                    <Grid item xs={12} md={3}>
                        <TextField
                            margin="normal"
                            fullWidth={true}
                            label="CUIT"
                            disabled={disabledCUIT}
                            aria-owns={open ? "mouse-over-popover" : undefined}
                            aria-haspopup="true"
                            onMouseEnter={(e) => {
                                cuit?.length === 0 && handlePopoverOpen(e);
                            }}
                            onMouseLeave={handlePopoverClose}
                            onFocus={handlePopoverClose}
                            onClick={handlePopoverClose}
                            name="cuit"
                            error={valuesValidation["cuit"]}
                            helperText={
                                valuesValidation["cuit"] && "Obligatorio con 11 caracteres"
                            }
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment>
                                        <IconButton onClick={() => {
                                            if (action === FORM_ACTIONS.CREAR) {
                                                handleCuitAFIP()
                                            }
                                        }}>
                                            <Avatar
                                                className={classes.iconSmall}
                                                src={LogoAFIP}
                                            ></Avatar>
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                            value={`${cuit || ""}`}
                            autoComplete="off"
                            autoFocus
                            onChange={(e) => {
                                handleCUITChange(e);
                            }}
                            inputProps={{
                                maxLength: 11,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={9}>
                        <TextField
                            margin="normal"
                            fullWidth={true}
                            disabled={action === FORM_ACTIONS.VER}
                            label="Denominacion"
                            name="denominacion"
                            value={`${denominacion || ""}`}
                            autoComplete="off"
                            onChange={(e) => {
                                handleInputChangeValidation(e);
                                handleInputChange(e);
                            }}
                            error={valuesValidation["denominacion"]}
                            helperText={valuesValidation["denominacion"] && "Obligatorio"}
                            required={true}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={1}>
                    <Grid item xs={12} md={3}>
                        <TextField
                            margin="normal"
                            fullWidth={true}
                            label="Domicilio"
                            name="domicilio"
                            disabled={action === FORM_ACTIONS.VER}
                            value={`${domicilio || ""}`}
                            autoComplete="off"
                            error={valuesValidation["domicilio"]}
                            helperText={valuesValidation["domicilio"] && "Obligatorio"}
                            required={true}
                            onChange={(e) => {
                                handleInputChangeValidation(e);
                                handleInputChange(e);
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextField
                            margin="normal"
                            disabled={action === FORM_ACTIONS.VER}
                            inputProps={{ maxLength: 4 }}
                            value={codigoPostal || ""}
                            onChange={(e) => {
                                handleCPChange(e);
                                handleInputChangeValidation(e);
                            }}
                            label="Cod. Postal"
                            name="codigoPostal"
                            error={valuesValidation["codigoPostal"]}
                            helperText={valuesValidation["codigoPostal"] && "Obligatorio"}
                            required={true}
                            autoComplete="off"
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <CboLocalidades
                            manejadorInputChange={(e) => {
                                handleLocalidadChange(e);
                                handleInputChangeValidation(e);
                            }}
                            manejadorInputChangeValidation={handleInputChangeValidation}
                            valuesValidation={valuesValidation}
                            valor={idLocalidad}
                            name="idLocalidad"
                            deshabilitado={action === FORM_ACTIONS.VER}
                            cp={codigoPostal ? codigoPostal : 0}
                            idPanel={action === FORM_ACTIONS.VER && 'idTabConsulta'}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <CboProvincias
                            manejadorInputChange={handleInputChange}
                            valor={idProvincia}
                            deshabilitado={true}
                            manejadorInputChangeValidation={handleInputChangeValidation}
                            valuesValidation={valuesValidation}
                            idPanel={action === FORM_ACTIONS.VER && 'idTabConsulta'}
                        />
                    </Grid>
                    <Grid item xs={2} style={{ display: "none" }}>
                        <CboSeccionales
                            manejadorInputChange={handleInputChange}
                            valor={idSeccional}
                            name="idSeccional"
                            manejadorInputChangeValidation={handleInputChangeValidation}
                            valuesValidation={valuesValidation}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={1}>
                    <Grid item xs={12} md={3}>
                        <TextField
                            margin="normal"
                            value={email || ""}
                            disabled={action === FORM_ACTIONS.VER}
                            error={valuesValidation["email"]}
                            helperText={valuesValidation["email"] && "Invalido"}
                            onChange={(e) => {
                                handleInputChange(e);
                                handleInputChangeValidation(e);
                            }}
                            onBlur={() => {
                                validateEmail(email);
                            }}
                            required={true}
                            label="EMail"
                            name="email"
                            autoComplete="off"
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            margin="normal"
                            disabled={action === FORM_ACTIONS.VER}
                            value={telefono || ""}
                            onChange={(e) => {
                                handleTelefonoChange(e);
                                handleInputChangeValidation(e);
                            }}
                            label="Telefono"
                            error={valuesValidation["telefono"]}
                            helperText={valuesValidation["telefono"] && "Obligatorio"}
                            required={true}
                            name="telefono"
                            autoComplete="off"
                        />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                margin="normal"
                                disabled={action === FORM_ACTIONS.VER}
                                id="dialogfechaAlta"
                                label="Fec. Alta."
                                format="dd/MM/yyyy"
                                okLabel="Aceptar"
                                required={true}
                                maxDate={new Date()} //maxDate
                                clearLabel="Limpiar"
                                cancelLabel="Cancelar"
                                value={moment(fechaAlta).isValid() ? moment(fechaAlta) : ""}
                                onChange={(date) => {
                                    setearValor("fechaAlta", date);
                                }}
                                KeyboardButtonProps={{
                                    "aria-label": "change date",
                                }}
                                fullWidth
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                margin="normal"
                                disabled={action !== FORM_ACTIONS.MODIFICAR}
                                id="dialogfechaBaja"
                                label="Fec. Baja."
                                format="dd/MM/yyyy"
                                okLabel="Aceptar"
                                maxDate={new Date()} //maxDate
                                clearLabel="Limpiar"
                                cancelLabel="Cancelar"
                                value={moment(!!fechaBaja).isValid() ? moment(fechaBaja) : null}
                                onChange={(date) => {
                                    setearValor("fechaBaja", date);
                                }}
                                KeyboardButtonProps={{
                                    "aria-label": "change date",
                                }}
                                fullWidth
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <FormControlLabel
                            style={{
                                cursor: "auto",
                            }}
                            control={
                                <Fragment>
                                    <Checkbox
                                        name="seguimiento"
                                        aria-describedby={idPopSeguimiento}
                                        checked={seguimiento}
                                        onChange={handleChangeCheckbox}
                                        disabled={action === FORM_ACTIONS.VER}
                                    />
                                    <Typography
                                        onMouseOver={
                                            seguimiento === true ? editarSeguimiento : null
                                        }
                                        style={{
                                            color:
                                                action === FORM_ACTIONS.VER
                                                    ? "#bebebe"
                                                    : "black",
                                        }}
                                    >
                                        Seguimiento
                                    </Typography>
                                </Fragment>
                            }
                        ></FormControlLabel>
                        <Popover
                            id={idPopSeguimiento}
                            open={openPopSeguimiento}
                            onClose={handleClosePopSeguimiento}
                            anchorEl={anchorElSE}
                            anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "left",
                            }}
                            transformOrigin={{
                                vertical: "center",
                                horizontal: "left",
                            }}
                            PaperProps={{
                                style: { width: "200px", height: "250px" },
                            }}
                        >
                            <Card className={classes.root2} variant="outlined">
                                <CardContent>
                                    <Typography
                                        className={classes.title}
                                        color="textSecondary"
                                        gutterBottom
                                    >
                                        Aviso de Seguimiento
                                    </Typography>
                                    <TextField
                                        id="txtFechaSeguimiento"
                                        name="fechaAviso"
                                        label="Fecha Aviso"
                                        type="date"
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{
                                            shrink: true,
                                            min: moment(new Date())
                                                .format("YYYY-MM-DD")
                                                .toString(),
                                        }}
                                        value={moment(fechaAviso).format("YYYY-MM-DD") || ""}
                                        className={classes.textField}
                                        onChange={handleInputChange}
                                    />
                                    <TextField
                                        id="txtmensajeSeguimiento"
                                        name="observacionSeguimiento"
                                        placeholder="Ingrese Mensaje"
                                        multiline
                                        onChange={handleInputChange}
                                        value={observacionSeguimiento || ""}
                                    />
                                    <Fab
                                        className={classes.fab}
                                        size="small"
                                        onClick={handleSeguimientoAdd}
                                        color="primary"
                                        aria-label="add"
                                    >
                                        <AssignmentReturn />
                                    </Fab>
                                </CardContent>
                            </Card>
                        </Popover>
                    </Grid>
                    {datosSuspensionEmpresa && datosSuspensionEmpresa.habilitaSuspender === 1 && (
                        <Grid item xs={12} md={1} style={{ marginTop: '1.6rem', marginLeft: '0.5rem' }}>
                            <FormControlLabel
                                control={<Switch
                                    checked={formValues.suspendida}
                                    value={suspendida}
                                    onChange={handleChangeSwitchSuspension}
                                    classes={{ switchBase: classes.switchBase, checked: classes.checked, track: classes.track }}
                                />
                                }
                                label="Suspension"
                                disabled={action !== FORM_ACTIONS.MODIFICAR}
                            />
                        </Grid>
                    )}
                    <Grid container style={{ display: "flex" }}>
                        <Grid item xs={12} md={2} >
                            <FormControlLabel
                                control={<Checkbox
                                    checked={datosSuspensionEmpresa?.enInspeccion}
                                    disabled={true}
                                />
                                }
                                label="Inspección Asignada"
                                disabled={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={2} style={{ marginRight: '0.5rem' }}>
                            <TextField
                                value={datosSuspensionEmpresa?.perInicio || ""}
                                fullWidth
                                disabled={true}
                                label="Ultima Acta Periodo Desde"
                                name="deuda"
                                autoComplete="off"
                            />

                        </Grid>
                        <Grid item xs={12} md={2} style={{ marginRight: '0.5rem' }}>
                            <TextField
                                value={datosSuspensionEmpresa?.perFin || ""}
                                fullWidth
                                disabled={true}
                                label="Ultima Acta Periodo Hasta"
                                name="deuda"
                                autoComplete="off"
                            />

                        </Grid>
                        <Grid item xs={12} md={2}>
                            <TextField
                                fullWidth
                                value={`$ ${datosSuspensionEmpresa?.deuda || "-"}`}
                                disabled={true}
                                label="Deuda Posterior al Acta"
                                name="deuda"
                                autoComplete="off"
                            />
                        </Grid>
                        <Grid item xs={12} md={1} style={{ marginLeft: '0.5rem' }}>
                            <TextField
                                value={datosSuspensionEmpresa?.cant_Afi || ""}
                                fullWidth
                                disabled={true}
                                label="Cant. Afiliados"
                                name="deuda"
                                autoComplete="off"
                            />
                        </Grid>
                        <Grid item xs={12} md={1} style={{ marginLeft: '0.5rem' }}>
                            <TextField
                                value={(datosSuspensionEmpresa?.actividad === true ? 'SI' : 'NO') || ""}
                                fullWidth
                                disabled={true}
                                label="De la Actividad"
                                name="DeLaActividad"
                                autoComplete="off"
                            />
                        </Grid>
                        <Grid item xs={12} md={1} style={{ marginTop: '0.5rem', marginLeft: '1rem' }}>
                            <Button variant="contained" color="primary" onClick={() => setAbrirModalAfiliados(true)}>
                                Ver Afiliados
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid container spacing={1} style={{ marginTop: "1rem", display: 'flex' }}>
                        <Grid item xs={12} md={9}>
                            <Typography display="block">Observaciones</Typography>
                            {observacionesEmpresa && (
                                observacionesEmpresa.map((item) => (
                                    <TextField
                                        disabled={true}
                                        onChange={handleInputChange}
                                        value={`${moment(item.fecha).format("DD/MM/YYYY  HH:mm")} - ${item.descripcion} - Usuario: ${item.usuario}`}
                                        name="observacion"
                                        fullWidth
                                        multiline
                                    />
                                )))}
                        </Grid>
                        <Grid style={{ marginTop: "2.5rem" }}>
                            <Button variant="contained" color="primary" onClick={() => setAbrirModalNuevaObservacion(true)}>
                                Agregar Observacion
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid container style={{ marginTop: "1rem" }}>
                        <Grid item xs={12}>
                            {
                                action !== FORM_ACTIONS.VER &&
                                <Button
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                    style={{ float: "right" }}
                                    startIcon={<SaveIcon />}
                                    onClick={handleSubmit}
                                >
                                    GUARDAR
                                </Button>
                            }

                        </Grid>
                    </Grid>
                </Grid>
                {confirmarSuspension && (
                    <AlertFinalizadoStepper
                        open={confirmarSuspension}
                        pregunta={"Suspension de cobertura"}
                        dialogText={suspendida ? `Quiere proceder con la suspension de cobertura?`
                            : `Quiere proceder con la ANULACIÓN de la suspension de cobertura?`}
                        buttonCancel={"Cancelar"}
                        buttonSubmit={"Continuar"}
                        handleClose={handleCloseAlert}
                        handleSend={suspensionCobertura}
                    />
                )}
            </ValidatorForm>
        </div>
    );
});
